import React from 'react';
import { createRoot } from 'react-dom/client'; // Fixed import
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { UserProvider } from './UserContext';

// Add error checking for the root element
const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element with id "root" not found');
}

const root = createRoot(container); // Fixed method call

root.render(
  <React.StrictMode>
    <UserProvider>
      <App />
    </UserProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
